import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UsersFacade } from './store/users.facade';
import { User } from '../models/users/user.model';

@Component({
  selector: 'rap-users',
  templateUrl: './users.container.component.html',
})
export class UsersContainerComponent {
  users$ = this.usersFacade.users$;
  usersCount$ = this.usersFacade.usersCount$;
  page: number;
  constructor(
    private router: Router,
    private usersFacade: UsersFacade,
  ) { }

  ngOnInit() {
    this.usersFacade.getUsers(1, '', '', '', 10);
  }

  getUsers(event: { search: string, page: number, sortBy: string, order: string, limit: number }) {
    console.log(event.page)
    this.page = event.page;
    this.usersFacade.getUsers(event.page, event.search, event.sortBy, event.order, event.limit);
  }

  deleteUser(event: { id: string, search: string, page: number, sortBy: string, order: string, limit: number }) {
    this.usersFacade.deleteUser(event.id);
    this.usersFacade.getUsers(event.page, event.search, event.sortBy, event.order, event.limit);
  }

  editUser(user: User) {
    this.router.navigate(['/dashboard/users/' + user.id + '/edit']);
  }

  approveUser(id: string) {
    this.usersFacade.approveUser(id);
  }

  performAction(data: any) {
    console.log(data)
    this.usersFacade.performAction(data);
  }
}
